import successIcon from '../../assets/check.png'
import './Success.css'

function RegisterSuccess({ navigation }) {
    return (
        <main className='advice'>
            <img src={successIcon} alt="Sucesso" />
            <h1>Sessão iniciada com sucesso!</h1>
        </main>
    )
}

export default RegisterSuccess;